import React from 'react'

/**
 * Get an async value
 * @param {Function} getAsyncValue - handler to be call to get the async value
 * @param {Array} deps - array of dependencies to watch to trigger value getter
 *
 * @return {[any, Boolean, any]} - the value with a loading state and a potential error
 */
export default function useAsyncValue(getValue, deps = []) {
  // init local state
  const [{ value, loading, error }, setState] = React.useState({ loading: true })

  // retrieve the value on deps change
  React.useEffect(
    () => {
      let allowed = true
      setState(state => ({ ...state, loading: true, error: undefined }))
      Promise.resolve(getValue())
        .then(value => allowed && setState(state => ({ ...state, loading: false, value })))
        .catch(error => allowed && setState(state => ({ ...state, loading: false, error })))
      return () => {
        allowed = false
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    deps
  )

  return [value, loading, error]
}
